"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNearHoldingsMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class GetNearHoldingsMapper {
    toDomain(result) {
        var _a, _b;
        const hasError = !!lodash_1.default.get(result, "errors");
        const isLoading = lodash_1.default.get(result, "loading");
        const holdingInfo = (_b = (_a = lodash_1.default.get(result, "data.nearHoldings.edges")) === null || _a === void 0 ? void 0 : _a.map((o) => (Object.assign({}, o === null || o === void 0 ? void 0 : o.node.holding)))) === null || _b === void 0 ? void 0 : _b.filter(({ foodi }) => foodi);
        return {
            hasError,
            isLoading,
            holdingInfo,
        };
    }
}
exports.GetNearHoldingsMapper = GetNearHoldingsMapper;
